<template>
    <div v-if="url" class="avatar circle" :class="{'big-avatar':big}" :style="{'background-image': `url(${url})`}"></div>
    <div v-else class="avatar circle" :class="{'big-avatar':big}"></div>
</template>

<script>
  export default {
    props: {
      base64: {
        type: String
      },
      md5: {
        type: String
      },
      src: {
        type: String,
        default: ''
      },
      big: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      url () {
        if (this.md5) {
          return `/profiel/avatar/${this.md5}`;
        }
        if (this.base64) {
          return this.base64;
        }
        if (this.src) {
          return this.src;
        }
        return null;
      }
    }
  };
</script>

<style>
    .circle {
        border-radius: 50%;
        border: 1px solid grey;
    }

    .avatar {
        background-size: cover;
        background-position: center center;
        width: 50px;
        height: 50px;
        background-image: url('/img/default_avatar.jpg');
    }
    .big-avatar{
      width: 100px;
      height: 100px;
    }
</style>
